<template>
    <div class="autohide-input">
        <input
            ref="input"
            v-model="query"
            type="text"
            class="pac-target-input input-normal"
            placeholder="Cerca indirizzo (min. 3 caratteri)..."
            @input="handleInput"
            @click="handleClick"
        />
        <GmapAutocomplete
            class="input-gmap"
            ref="AddressAutocomplete"
            v-bind:value="query_debounced"
            @input="handleInputGmap"
            @place_changed="emitPlaceChanged"
        />
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        input: null,
        AddressAutocomplete: null,

        query: '',
        query_debounced: '',

        length_of_query_min: 3,
        debounce_delay: 500,
      };
    },
    emits: ['place-changed'],
    methods: {

        debounce(fn, delay = this.debounce_delay) {
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn(...args), delay);
            };
        },
        emitPlaceChanged(place) {
            console.log("place 000", place);
            this.$emit('place-changed', place);
        },

        handleClick() {
            if(this.query.length < this.length_of_query_min) {
                return;
            }
            this.$refs.AddressAutocomplete.$el.focus();
        },

        handleInput() {
            if (!this._debouncedHandle && this.query.length >= this.length_of_query_min) {
                this._debouncedHandle = this.debounce(async () => {
                    this.query_debounced = this.query;
                    await this.$nextTick();
                    const el = this.$refs.AddressAutocomplete.$el;
                    // aggiungi a body class hide-suggestions_gmap
                    document.body.classList.remove('hide_suggestions_gmap');
                    el.focus();
                    // Sposta il cursore alla fine del valore
                    if (el.setSelectionRange) {
                        const len = el.value.length;
                        el.setSelectionRange(len, len);
                    }
                }, this.debounce_delay);
            }
            this._debouncedHandle();
        },

        async handleInputGmap() {
            this.query_debounced = this.$refs.AddressAutocomplete.$el.value;

            // const el_gmap = this.$refs.AddressAutocomplete.$el;

            const el = this.$refs.input;
            await this.$nextTick();
            this.query = this.query_debounced;
            document.getElementById('clickOutside').click();
            document.body.classList.add('hide_suggestions_gmap');
            
            el.focus();
            if (el.setSelectionRange) {
                const len = el.value.length;
                el.setSelectionRange(len, len);
            }
        },
    },
    async created() {
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 500));
        let addressAutocomplete = this.$refs?.AddressAutocomplete?.$autocomplete;
        if (addressAutocomplete && addressAutocomplete.setFields) {
        addressAutocomplete.setFields([
            'address_components',
            'formatted_address',
            'geometry',
            'name',
            'place_id'
        ]);
        }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .pac-target-input {
      border: 1px solid black;
      padding: 10px;
      border-radius: 3px;
      width: 100%;
  }



  .autohide-input {
    .input-gmap:not(:focus) {
      opacity: 0 !important;
      height: 0 !important;
      max-height: 0 !important;
      overflow: hidden !important;
      position: absolute !important;
    }

    .input-gmap:focus {
      opacity: 100;
      position: relative;
      height: auto;
      max-height: 100%;
    }
    &:has(.input-gmap:focus) .input-normal {
      opacity: 0;
      position: absolute;
      height: 0;
      max-height: 0;
      overflow: hidden;
    }
  }

  </style>